import { render, staticRenderFns } from "./TabGraficoLucroComponentesDeSeuCalculo.vue?vue&type=template&id=f6a42538&scoped=true&"
import script from "./TabGraficoLucroComponentesDeSeuCalculo.vue?vue&type=script&lang=js&"
export * from "./TabGraficoLucroComponentesDeSeuCalculo.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoLucroComponentesDeSeuCalculo.vue?vue&type=style&index=0&id=f6a42538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a42538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTabItem,VTabs})
